export default __webpack_public_path__ + "static/media/ellipsis.078620b6.svg";